// const userRoleEnums = {
//   28: 'Super Admin',
//   108: 'Hod',
//   134: 'Hr',
//   176: 'Assistant Manager',
//   107: 'Manager',
//   138: 'Trainer',
//   144: 'Agent',
//   142: 'TL',
// }
// module.exports = userRoleEnums

const userRoleEnums = {
  SUPER_ADMIN: 'super_admin',
  HR: 'hr',
  INTERVIEWER: 'interviewer',
  TRAINEE: 'trainee',
  TL: 'tl',
  HOD: 'hod',
  QUALITY: 'quality',
  TRAINER: 'trainer',
  EMPLOYEE: 'employee',
  ADMIN: 'admin',
  AGENT: 'agent',
}

const raisedRequest = {
  BACK_DATE_LEAVE: 'back_date_leave',
  ROSTER_CHANGE: 'roster_change',
  SHIFT_CHANGE: 'shift_change',
  BIOMETRIC_ISSUE: 'biometric_issue',
  WORKING_ON_WEEKOFF: 'working_on_weekoff',
  WORKING_ON_LEAVE: 'working_on_leave',
}

const statusEnums = {
  APPROVED: 1,
  REJECTED: 2,
  PENDING: 0,
  ALLOCATED: 3,
  UNALLOCATED: 2,
  REJECTEDAGENT: 4,
  ACTIVEAGENT: 5,
}

module.exports = { statusEnums, raisedRequest, userRoleEnums }
